import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-suivis',
  templateUrl: './suivis.component.html',
  styleUrls: ['./suivis.component.css']
})
export class SuivisComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
